import { render, staticRenderFns } from "./EditorProfilePassword.vue?vue&type=template&id=dd9258d8&scoped=true&"
import script from "./EditorProfilePassword.vue?vue&type=script&lang=js&"
export * from "./EditorProfilePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9258d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd9258d8')) {
      api.createRecord('dd9258d8', component.options)
    } else {
      api.reload('dd9258d8', component.options)
    }
    module.hot.accept("./EditorProfilePassword.vue?vue&type=template&id=dd9258d8&scoped=true&", function () {
      api.rerender('dd9258d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/userprofile/EditorProfilePassword.vue"
export default component.exports